<h1 *ngIf="!mobile"
    mat-dialog-title>
    {{ 'default.externalAreaImport.importAreas' | blah }}
</h1>

<div *ngIf="initializing">
    <hpo-placeholder type="input"></hpo-placeholder>
    <hpo-placeholder type="input"></hpo-placeholder>
    <hpo-placeholder type="row"></hpo-placeholder>
</div>

<div *ngIf="!initializing">

    <div class="form-container">

        <mat-form-field>
            <mat-label>{{ 'default.externalRequest.importAreaId' | blah }}</mat-label>
            <input matInput
                id="eai-area-id-input"
                type="text"
                [(ngModel)]="areaId"
                maxlength="500"
                required="true">
        </mat-form-field>

        <mat-form-field>
            <mat-label>{{ 'default.externalRequest.importTargetId' | blah }}</mat-label>
            <input matInput
                id="eai-nis-id-input"
                type="text"
                [(ngModel)]="nisId"
                maxlength="500"
                required="true">
        </mat-form-field>

    </div>

    <div class="history-container">

        <div>{{ 'default.externalRequest.requestHistory' | blah:[5] }}:</div>

        <div class="history-entries">

            <div *ngFor="let item of externalAreaImports">

                <ng-container [ngSwitch]="item.RequestState">
                    <mat-icon *ngSwitchCase="'InProgress'"
                        class="in-progress"
                        matTooltip="{{ 'default.externalRequest.requestInProgress' | blah }}"
                        matTooltipPosition="right"
                        matTooltipClass="hpo">refresh</mat-icon>
                    <mat-icon *ngSwitchCase="'Completed'"
                        class="completed"
                        matTooltip="{{ 'default.externalRequest.requestCompleted' | blah }}"
                        matTooltipPosition="right"
                        matTooltipClass="hpo">check_circle_outlined</mat-icon>
                    <mat-icon *ngSwitchCase="'Failed'"
                        class="failed"
                        matTooltip="{{ 'default.externalRequest.requestFailedWithCode' | blah:[item.RequestStatusCode || '-'] }}"
                        matTooltipPosition="right"
                        matTooltipClass="hpo">cancel_outlined</mat-icon>
                </ng-container>

                <mat-icon color="primary-500"
                    matTooltip="{{ 'default.externalRequest.importAreaId' | blah }}: {{item.RequestDescription}}"
                    matTooltipPosition="right"
                    matTooltipClass="hpo">
                    info
                </mat-icon>

                <div>
                    {{ item.RequestCreated | date:'d.M.yyyy H:mm' }},
                    {{item.RequesterName}},
                    {{item.CompanyName}}
                </div>

            </div>

            <i *ngIf="externalAreaImports.length === 0">
                {{ 'default.externalRequest.noPreviousRequests' | blah }}
            </i>

        </div>
    </div>

</div>

<mat-dialog-actions align="end">

    <button id="eai-cancel-button"
        mat-stroked-button
        mat-dialog-close>
        {{ 'default.cancel' | blah | uppercase }}
    </button>

    <button id="eai-submit-button"
        mat-stroked-button
        color="accent"
        [disabled]="initializing || submitting || !isFormValid"
        (click)="submit()">
        {{ 'default.sendRequest' | blah | uppercase }}
    </button>

</mat-dialog-actions>